import { render, staticRenderFns } from "./FormEditAndDetailPlan.vue?vue&type=template&id=93a55e42"
import script from "./FormEditAndDetailPlan.vue?vue&type=script&lang=js"
export * from "./FormEditAndDetailPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports